import SanityForm from "@/contents/forms/SanityForm"
import BlokWrapper from "@/contents/integrations/BlokWrapper"
import { ContactForm } from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import FormContainer from "@/ui/organisms/FormContainer"

export interface SanityContactFormProps {
  content: ContactForm
}

const SanityContactForm = ({ content }: SanityContactFormProps) => {
  return (
    <BlokWrapper
      contents={content}
      menuColor={content.color === "light" ? "text" : "textNegative"}
    >
      <FormContainer
        color={content.color}
        title={<SanityRichTextField value={content.title} />}
        subtitle={<SanityRichTextField value={content.subtitle} />}
        // cover={
        //   content.cover?.asset ? (
        //     <SanityImageField
        //       asset={content.cover.asset}
        //       width="100%"
        //       className="w-full"
        //     />
        //   ) : undefined
        // }
        message={<SanityRichTextField value={content.message} multiline />}
      >
        {content.form && <SanityForm content={content.form} />}
      </FormContainer>
    </BlokWrapper>
  )
}

export default SanityContactForm
